export default {"src":"/_next/static/media/recover.ea6f7eb6.gif","height":649,"width":1195};